export function toFixed<TValue extends number | string>(value: TValue): string {
  let parsedValue: number;
  if (typeof value === 'number') {
    parsedValue = value;
  } else {
    parsedValue = parseFloat(value);
  }
  return parsedValue.toFixed(8);
}
